import React from 'react';
import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from 'material-ui-next/Table';
import Tooltip from 'material-ui-next/Tooltip';
import Checkbox from 'material-ui-next/Checkbox';
import CSSModules from 'react-css-modules';
import styles from './table.css';
import IconButton from 'material-ui-next/IconButton';
import FirstPageIcon from '../assets/icons/firstPageIcon.react.js';
import LastPageIcon from '../assets/icons/lastPageIcon.react.js';
import PrevPageIcon from '../assets/icons/prevPageIcon.react.js';
import NextPageIcon from '../assets/icons/nextPageIcon.react.js';
import Fade from 'material-ui-next/transitions/Fade';
import {
  LinearProgress
} from 'material-ui-next/Progress';
import {
  withStyles
} from 'material-ui-next/styles';

class _TablePaginationActions extends React.Component {
  handleFirstPageButtonClick = event => {
    this.props.onChangePage(event, 0);
  };

  handleBackButtonClick = event => {
    this.props.onChangePage(event, this.props.page - 1);
  };

  handleNextButtonClick = event => {
    this.props.onChangePage(event, this.props.page + 1);
  };

  handleLastPageButtonClick = event => {
    this.props.onChangePage(
      event,
      Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) -
        1),
    );
  };

  render() {
    const {
      count,
      page,
      rowsPerPage
    } = this.props;

    var first_page_style = null
    var prev_page_style = null
    var next_page_style = null
    var last_page_style = null

    if (page === 0) {
      first_page_style = "table-button-disabled"
      prev_page_style = "table-button-disabled"
    }

    if (page >= Math.ceil(count / rowsPerPage) - 1) {
      next_page_style = "table-button-disabled"
      last_page_style = "table-button-disabled"
    }

    return (
      <div styleName="table-pager">
        <IconButton
          onClick={this.handleFirstPageButtonClick}
          disabled={page === 0}
          styleName={first_page_style}
          aria-label="First Page"
        >
          <FirstPageIcon />
        </IconButton>
        <IconButton
          onClick={this.handleBackButtonClick}
          disabled={page === 0}
          styleName={prev_page_style}
          aria-label="Previous Page"
        >
          <PrevPageIcon />
        </IconButton>
        <IconButton
          onClick={this.handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          styleName={next_page_style}
          aria-label="Next Page"
        >
          <NextPageIcon />
        </IconButton>
        <IconButton
          onClick={this.handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          styleName={last_page_style}
          aria-label="Last Page"
        >
          <LastPageIcon />
        </IconButton>
      </div>
    );
  }
}

_TablePaginationActions.defaultProps = {
  onChangePage: null,
  onChangeRowsPerPage: null,
  count: 0,
  rowsPerPage: 10,
  page: 0
}

export const TablePaginationActions = CSSModules(_TablePaginationActions,
  styles)

const HeadStyles = theme => ({
  typeHead: {
    height: 5
  },
  progress: {
    maxWidth: 120
  }
})

export class _EnhancedTableHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const {
      classes,
      loading,
      enableSelect,
      onSelectAllClick,
      order,
      orderBy,
      numSelected,
      rowCount,
      columnConfigs
    } = this.props;

    return (
      <TableHead>
        <Fade in={loading}>
          <TableRow classes={{typeHead: classes.typeHead}}>
            <LinearProgress classes={{root: classes.progress}}/>
          </TableRow>
        </Fade>
        <TableRow>
          {enableSelect && (
             <TableCell padding="checkbox">
               <Checkbox
                 indeterminate={numSelected > 0 && numSelected < rowCount}
                 checked={numSelected === rowCount}
                 onChange={onSelectAllClick}
               />
             </TableCell>
          )}
          {columnConfigs.map((column) => {
             if (column.disable) {
               return null
             }
             return (
               <TableCell
                 key={column.id}
                 numeric={column.numeric}
                 padding={column.disablePadding ? 'none' : 'default'}
                 sortDirection={(!column.disableSort && orderBy === column.id) ? order : false}
                 >
                 <Tooltip
                   title={(!column.disableSort)? "Sort" : "not Sortable"}
                   placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                   enterDelay={300}
                 >
                   <TableSortLabel
                     active={orderBy === column.id}
                     direction={order}
                     onClick={this.createSortHandler(column.id)}
                   >
                     {column.label}
                   </TableSortLabel>
                 </Tooltip>
               </TableCell>
             );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

_EnhancedTableHead.defaultProps = {
  loading: false,
  enableSelect: false,
  numSelected: 0,
  onRequestSort: null,
  onSelectAllClick: null,
  order: 'asc',
  orderBy: {},
  rowCount: 0,
  columnConfigs: {},
};

export const EnhancedTableHead = withStyles(HeadStyles)(_EnhancedTableHead)



// WEBPACK FOOTER //
// ./src/widgets/table_utils.react.js